import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnMount: true, // refetch when component is (re-)mounted
      refetchOnWindowFocus: true, // refetch when window is focused
      retry: 0, // if query fails it will retry once before erroring
    },
  },
});

interface Props {
  children: React.ReactNode;
}

export const QueryProvider = (props: Props) => {
  return (
    <QueryClientProvider client={queryClient}>
      {props.children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};
